import { IKeyValueStrNum } from 'ICommonTypes'

const replaceSearchParam = (
  paramName: string,
  paramValue: string | number | null,
  searchParams: any,
  setSearchParams: any,
  replaceHistory?: boolean
) => {
  if (paramValue || paramValue === 0) {
    let obj: any = {}
    obj[paramName] = paramValue
    setSearchParams(
      { ...Object.fromEntries(searchParams.entries()), ...obj },
      { replace: !!replaceHistory }
    )
  } else {
    let obj: any = { ...Object.fromEntries(searchParams.entries()) }
    delete obj[paramName]
    setSearchParams(obj, { replace: !!replaceHistory })
  }
}

const replaceSearchParams = (
  params: Array<IKeyValueStrNum>,
  searchParams: any,
  setSearchParams: any
) => {
  let obj: any = { ...Object.fromEntries(searchParams.entries()) }
  params.forEach((item) => {
    if (item.value || item.value === 0) obj[item.key] = item.value
    else delete obj[item.key]
  })

  setSearchParams(obj)
}

const removeSearchParam = (
  paramName: string,
  searchParams: any,
  setSearchParams: any
) => {
  let obj = Object.fromEntries(searchParams.entries())
  delete obj[paramName]
  setSearchParams(obj)
}

const renderRef = (
  pathname: string,
  paramsProp: IKeyValueStrNum[] | IKeyValueStrNum,
  searchParams?: URLSearchParams
) => {
  let pathname_str = '/' + pathname + '?'
  let param_str = ''
  let params: IKeyValueStrNum[] = []
  if (!Array.isArray(paramsProp)) {
    params = [paramsProp]
  } else {
    params = paramsProp
  }

  searchParams?.forEach((value, key) => {
    const keyValuePassedParam = params.find((param) => param.key === key)
    if (!keyValuePassedParam) {
      param_str += '&' + key + '=' + value
    }
  })

  params.forEach((element) => {
    // if (element.value || element.value === 0) {
    param_str += '&' + element.key + '=' + element.value
    // }
  })

  return pathname_str + param_str.slice(1)
}

export { replaceSearchParam, replaceSearchParams, removeSearchParam, renderRef }
